import { Injectable } from '@angular/core';
import { BackendService } from './backend.service';
import { environment } from '../../../environments/environment';
import { LmEvent, LmEventRaw, LmEventsResponse } from '../models';
import { catchError, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { head } from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class EventsService {
  constructor(private backendService: BackendService) {}

  getAllEvents(): Observable<LmEvent[]> {
    return this.backendService.getWithType<LmEventsResponse>(`${environment.baseUrl}/event/completed_live/`).pipe(
      map((response) => {
        const { events = [] } = response || {};
        return events?.map((item) => this.mapEventResponse(item));
      }),
      catchError((errorRes) => throwError(errorRes)),
    );
  }

  getFirstUpcomingEvent(): Observable<LmEvent> {
    return this.backendService.getWithType<LmEventsResponse>(`${environment.baseUrl}/event/live/`).pipe(
      map((eventData) => this.mapEventResponse(head(eventData.events))),
      catchError((errorRes) => throwError(errorRes)),
    );
  }

  mapEventResponse(eventData: LmEventRaw): LmEvent {
    return {
      capacity: eventData?.capacity,
      name: eventData?.name?.text,
      description: eventData?.description?.text,
      logo: eventData?.logo?.url,
      start: eventData?.start?.local,
      url: eventData?.url,
    };
  }
}
